import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useAuthStore } from '@/store/useAuthStore'
import { createAppTheme } from '@/lib/theme'
import PinAuthScreen from '@/components/auth/PinAuthScreen'
import AppRouter from '@/components/layout/AppRouter'
import InstallPrompt from '@/components/pwa/InstallPrompt'

function App() {
  const { isAuthenticated } = useAuthStore()
  const theme = createAppTheme()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {isAuthenticated ? <AppRouter /> : <PinAuthScreen />}
        <InstallPrompt />
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
